import script from "./ActivityManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityManagement.vue?vue&type=script&setup=true&lang=js"

import "./ActivityManagement.vue?vue&type=style&index=0&id=27c8bcd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27c8bcd2"]])

export default __exports__